var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "settingsModal",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "ModalLabel"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "form",
            {
              staticClass: "form-horizontal",
              attrs: { id: "oc-backend-settings-form", method: "post" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "col-xs-6 control-label" }, [
                    _vm._v("Заявок на странице:")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-6" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newSettings.backend_count,
                          expression: "newSettings.backend_count"
                        }
                      ],
                      staticClass: "oc-form__control",
                      attrs: {
                        type: "number",
                        name: "settings[backend_count]",
                        placeholder: "",
                        min: "1"
                      },
                      domProps: { value: _vm.newSettings.backend_count },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.newSettings,
                            "backend_count",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "col-xs-6 control-label" }, [
                    _vm._v("Выводить выполненные заявки:")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-6" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newSettings.backend_status_1,
                          expression: "newSettings.backend_status_1"
                        }
                      ],
                      staticClass: "slide-checkbox",
                      attrs: {
                        id: "status-1",
                        type: "checkbox",
                        name: "settings[backend_status_1]",
                        "true-value": 1,
                        "false-value": 0,
                        title: ""
                      },
                      domProps: {
                        checked: Array.isArray(_vm.newSettings.backend_status_1)
                          ? _vm._i(_vm.newSettings.backend_status_1, null) > -1
                          : _vm._q(_vm.newSettings.backend_status_1, 1)
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.newSettings.backend_status_1,
                            $$el = $event.target,
                            $$c = $$el.checked ? 1 : 0
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.newSettings,
                                  "backend_status_1",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.newSettings,
                                  "backend_status_1",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.newSettings, "backend_status_1", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", {
                      attrs: { for: "status-1", title: "Вкл/Выкл" }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "col-xs-6 control-label" }, [
                    _vm._v("Включить фильтр по дате:")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-6" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newSettings.backend_filter_date,
                          expression: "newSettings.backend_filter_date"
                        }
                      ],
                      staticClass: "slide-checkbox",
                      attrs: {
                        id: "backend_filter_date",
                        type: "checkbox",
                        name: "settings[backend_filter_date]",
                        "true-value": 1,
                        "false-value": 0,
                        title: ""
                      },
                      domProps: {
                        checked: Array.isArray(
                          _vm.newSettings.backend_filter_date
                        )
                          ? _vm._i(_vm.newSettings.backend_filter_date, null) >
                            -1
                          : _vm._q(_vm.newSettings.backend_filter_date, 1)
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.newSettings.backend_filter_date,
                            $$el = $event.target,
                            $$c = $$el.checked ? 1 : 0
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.newSettings,
                                  "backend_filter_date",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.newSettings,
                                  "backend_filter_date",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.newSettings,
                              "backend_filter_date",
                              $$c
                            )
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", {
                      attrs: { for: "backend_filter_date", title: "Вкл/Выкл" }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "col-xs-6 control-label" }, [
                    _vm._v("Быстрые ссылки для заявок:")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-6" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newSettings.backend_fast_link,
                          expression: "newSettings.backend_fast_link"
                        }
                      ],
                      staticClass: "slide-checkbox",
                      attrs: {
                        id: "fast-link",
                        type: "checkbox",
                        name: "settings[backend_fast_link]",
                        "true-value": 1,
                        "false-value": 0,
                        title: ""
                      },
                      domProps: {
                        checked: Array.isArray(
                          _vm.newSettings.backend_fast_link
                        )
                          ? _vm._i(_vm.newSettings.backend_fast_link, null) > -1
                          : _vm._q(_vm.newSettings.backend_fast_link, 1)
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.newSettings.backend_fast_link,
                            $$el = $event.target,
                            $$c = $$el.checked ? 1 : 0
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.newSettings,
                                  "backend_fast_link",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.newSettings,
                                  "backend_fast_link",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.newSettings, "backend_fast_link", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", {
                      attrs: { for: "fast-link", title: "Вкл/Выкл" }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "col-xs-6 control-label" }, [
                    _vm._v("Статусы заявок:")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-6" }, [
                    _c(
                      "div",
                      { staticClass: "checkbox-group" },
                      _vm._l(_vm.newSettings.backend_status, function(
                        active,
                        index
                      ) {
                        return index > 1
                          ? _c("div", { key: index, staticClass: "checkbox" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.newSettings.backend_status[index],
                                    expression:
                                      "newSettings.backend_status[index]"
                                  }
                                ],
                                staticClass: "hidding-checkbox",
                                attrs: {
                                  id: "check-status-" + index,
                                  type: "checkbox",
                                  "true-value": 1,
                                  "false-value": 0
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.newSettings.backend_status[index]
                                  )
                                    ? _vm._i(
                                        _vm.newSettings.backend_status[index],
                                        null
                                      ) > -1
                                    : _vm._q(
                                        _vm.newSettings.backend_status[index],
                                        1
                                      )
                                },
                                on: {
                                  change: function($event) {
                                    var $$a =
                                        _vm.newSettings.backend_status[index],
                                      $$el = $event.target,
                                      $$c = $$el.checked ? 1 : 0
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.newSettings.backend_status,
                                            index,
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.newSettings.backend_status,
                                            index,
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.newSettings.backend_status,
                                        index,
                                        $$c
                                      )
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("label", {
                                attrs: {
                                  for: "check-status-" + index,
                                  title: "Вкл/Выкл"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "check-status-" + index } },
                                [_vm._v(_vm._s(_vm.statusName[index]))]
                              )
                            ])
                          : _vm._e()
                      }),
                      0
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "col-xs-6 control-label" }, [
                    _vm._v("Поля формы:")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-6" }, [
                    _c("table", { staticClass: "table sort ui-sortable" }, [
                      _c(
                        "tbody",
                        {
                          directives: [
                            {
                              name: "sortable",
                              rawName: "v-sortable",
                              value: _vm.getSortParams(),
                              expression: "getSortParams()"
                            }
                          ]
                        },
                        _vm._l(_vm.newSettings.backend_fields_sorted, function(
                          setting,
                          index
                        ) {
                          return _c(
                            "tr",
                            {
                              key: index,
                              staticStyle: { opacity: "1", "z-index": "0" }
                            },
                            [
                              _vm._m(1, true),
                              _vm._v(" "),
                              _c("td", { staticClass: "td-field-name" }, [
                                _c(
                                  "label",
                                  { attrs: { for: "check-field-" + setting } },
                                  [_vm._v(_vm._s(_vm.fieldName[setting]))]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("div", { staticClass: "checkbox" }, [
                                  _c("input", { attrs: { type: "hidden" } }),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.newSettings.backend_fields[
                                            setting
                                          ],
                                        expression:
                                          "newSettings.backend_fields[setting]"
                                      }
                                    ],
                                    staticClass: "hidding-checkbox",
                                    attrs: {
                                      id: "check-field-" + setting,
                                      type: "checkbox",
                                      "true-value": 1,
                                      "false-value": 0
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.newSettings.backend_fields[setting]
                                      )
                                        ? _vm._i(
                                            _vm.newSettings.backend_fields[
                                              setting
                                            ],
                                            null
                                          ) > -1
                                        : _vm._q(
                                            _vm.newSettings.backend_fields[
                                              setting
                                            ],
                                            1
                                          )
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a =
                                            _vm.newSettings.backend_fields[
                                              setting
                                            ],
                                          $$el = $event.target,
                                          $$c = $$el.checked ? 1 : 0
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.newSettings.backend_fields,
                                                setting,
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.newSettings.backend_fields,
                                                setting,
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.newSettings.backend_fields,
                                            setting,
                                            $$c
                                          )
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("label", {
                                    attrs: {
                                      for: "check-field-" + setting,
                                      title: "Вкл/Выкл"
                                    }
                                  })
                                ])
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-success",
                    attrs: { href: "#" },
                    on: { click: _vm.save }
                  },
                  [_vm._v("Сохранить")]
                )
              ])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
      _vm._v(" "),
      _c("h4", { staticClass: "modal-title", attrs: { id: "ModalLabel" } }, [
        _vm._v("Настройки страницы заявок")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("i", {
        staticClass: "oc-icon16 ico-sort sort sort-handle",
        attrs: { title: "Переместить" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-381ccc66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-381ccc66","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/backend/components/dialogs/SettingsModal.vue
// module id = 203
// module chunks = 1